export const ACH_PAYMENTS_CONTAINER_TAG_NAME = 'ach-payments-container';
